/* Casca Rija: temporary native-privacy priority over Forms popup 1221523.
 * UI only. No consent calls, dismissal, submission or visitor-state writes.
 * Candidate: real Shopify Forms focus-trap QA is a release gate.
 */
(() => {
  'use strict';
  const singleton = '__crPrivacyPriority20261102';
  if (window[singleton]) return;
  window[singleton] = true;

  const hostId = 'app-embed-container-1221523';
  const prefs = [
    'shopify-pc__prefs__header-close', 'shopify-pc__prefs__header-save',
    'shopify-pc__prefs__header-accept', 'shopify-pc__prefs__header-decline'
  ];
  const banner = [
    'shopify-pc__banner__btn-manage-prefs',
    'shopify-pc__banner__btn-accept', 'shopify-pc__banner__btn-decline'
  ];
  let suspended = null;
  let queued = false;

  function rendered(element) {
    if (!element || !element.isConnected) return false;
    const rect = element.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return false;
    if (typeof element.checkVisibility === 'function') {
      return element.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true });
    }
    // Check ancestors' CSS, NOT their rectangles: native prefs root can be 0px high.
    if (getComputedStyle(element).visibility !== 'visible') return false;
    for (let node = element; node; node = node.parentElement) {
      const css = getComputedStyle(node);
      if (css.display === 'none' || Number(css.opacity) === 0) return false;
    }
    return true;
  }

  function privacyControl() {
    return prefs.concat(banner).map(id => document.getElementById(id)).find(rendered);
  }

  function deepActive() {
    let active = document.activeElement;
    while (active && active.shadowRoot && active.shadowRoot.activeElement) {
      active = active.shadowRoot.activeElement;
    }
    return active;
  }

  function inside(element, host) {
    for (let node = element; node; node = node.parentNode || node.host) {
      if (node === host) return true;
    }
    return false;
  }

  function enforce(state) {
    const host = state.host;
    if (host.style.getPropertyValue('display') !== 'none' ||
        host.style.getPropertyPriority('display') !== 'important') {
      // Preserve latest app-owned display if it changes during suspension.
      state.beforeStyle = host.getAttribute('style');
      state.display = host.style.getPropertyValue('display');
      state.priority = host.style.getPropertyPriority('display');
      host.style.setProperty('display', 'none', 'important');
      state.appliedStyle = host.getAttribute('style');
    }
    if (!host.hasAttribute('inert')) {
      host.setAttribute('inert', '');
      state.addedInert = true;
    }
  }

  function restore(state) {
    const host = state.host;
    if (host.getAttribute('style') === state.appliedStyle) {
      if (state.beforeStyle === null) host.removeAttribute('style');
      else host.setAttribute('style', state.beforeStyle);
    } else if (host.style.getPropertyValue('display') === 'none' &&
               host.style.getPropertyPriority('display') === 'important') {
      // An app changed other styles: preserve those changes, restore only display.
      if (state.display) host.style.setProperty('display', state.display, state.priority);
      else host.style.removeProperty('display');
    }
    if (state.addedInert && host.getAttribute('inert') === '') host.removeAttribute('inert');
  }

  function sync() {
    queued = false;
    const control = privacyControl();
    const found = document.getElementById(hostId);
    const host = found && found.localName === 'shopify-forms-embed' ? found : null;
    if (suspended && (!control || host !== suspended.host)) {
      const previous = suspended;
      suspended = null;
      const active = deepActive();
      const mayReturn = !control && (active === document.body ||
        (active && /^(shopify-pc__prefs|shopify-pc__banner)/.test(active.id) && !rendered(active)));
      restore(previous);
      if (mayReturn && previous.focus && rendered(previous.focus)) {
        previous.focus.focus({ preventScroll: true });
      }
    }
    if (!control || !host) return;
    if (!suspended) {
      const active = deepActive();
      suspended = { host, focus: inside(active, host) ? active : null, addedInert: false };
      // Remember even a pre-existing display:none!important; restoration must be exact.
      suspended.beforeStyle = host.getAttribute('style');
      suspended.display = host.style.getPropertyValue('display');
      suspended.priority = host.style.getPropertyPriority('display');
      suspended.appliedStyle = suspended.beforeStyle;
      enforce(suspended);
      if (suspended.focus && !control.disabled && !control.closest('[inert]')) {
        control.focus({ preventScroll: true });
      }
    } else enforce(suspended);
  }

  function schedule() {
    if (!queued) {
      queued = true;
      queueMicrotask(sync);
    }
  }

  function start() {
    const observer = new MutationObserver(schedule);
    observer.observe(document.documentElement, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['style', 'class', 'hidden', 'inert', 'aria-hidden', 'id']
    });
    sync();
    // CSS/media transitions and late app hosts need coverage beyond DOM mutations.
    window.setInterval(sync, 500);
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('visibilitychange', schedule);
    document.addEventListener('focusin', event => {
      const control = privacyControl();
      const host = document.getElementById(hostId);
      if (control && host && event.composedPath().includes(host)) {
        sync();
        if (!control.disabled && !control.closest('[inert]')) control.focus({ preventScroll: true });
      }
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
